import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClone = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 512 512",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M64 496H288c26.5 0 48-21.5 48-48V384h16v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h64v16H64c-26.5 0-48 21.5-48 48V448c0 26.5 21.5 48 48 48zM176 288c0 26.5 21.5 48 48 48H448c26.5 0 48-21.5 48-48V64c0-26.5-21.5-48-48-48H224c-26.5 0-48 21.5-48 48V288zm-16 0V64c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V288c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64z" })
});
export default SvgClone;
